<template>
<div class="container">
  <div class="couponlist">
    <img src="/static/images/b1.png">
    <div class="progress_d" v-if="prograsstxt > 0">{{prograsstxt == 100?'抢完了':'已抢'+prograsstxt+'%'}}</div>
    <div class="scc">
      <div class="progress_c">
        <van-progress :percentage="parseInt(prograsstxt)" stroke-width="15"  color="#f9b016" track-color="#fd9174" pivot-text=" " />
      </div>
      <div>
        <span class="m">{{totaltxt.value}}</span>{{totaltxt.unit}}
      </div>
    </div>
    <div class="sc">
      <van-checkbox-group v-model="result">
        <van-row class="item" v-for="(item,index) in couponlist" :key="index" v-if="index<=1">
          <van-col span="3" class="ck"><van-checkbox :name="item.actid" checked-color="#fb5b41"></van-checkbox></van-col>
          <van-col span="21">
            <img src="/static/images/cp1.png?v=1" v-if="index == 0"/>
            <img src="/static/images/cp2.png?v=1" v-if="index == 1"/>
            <!--          <div class="info">-->
            <!--            <div class="l">-->
            <!--              <div>{{item.money}}元</div>-->
            <!--              <div>{{item.type == 1 ? '现金券':'满减券'}}</div>-->
            <!--            </div>-->
            <!--            <div class="r">-->
            <!--              <div>-->
            <!--                {{item.name}}-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                {{item.content}}-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                {{item.desc}}-->
            <!--              </div>-->
            <!--            </div>-->
            <!--          </div>-->
          </van-col>
        </van-row>
      </van-checkbox-group>
    </div>
  </div>

  <div class="qgbtn" @click="gobuy">
    <img src="/static/images/btn1.png"/>
  </div>
<!--  <div class="bfooter">-->
<!--    <div class="ck"><van-checkbox v-model="checked" checked-color="#fb5b41" @click="handleCheckAll">全选</van-checkbox></div>-->
<!--    <div class="btn" @click="gobuy">去抢购</div>-->
<!--  </div>-->
</div>
</template>

<script>
import { Col, Row, Checkbox, CheckboxGroup, Progress } from 'vant'
import { isWeixin, fenxiang, isApp, getQueryString } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'

export default {
  components: {[Checkbox.name]: Checkbox, [CheckboxGroup.name]: CheckboxGroup, [Col.name]: Col, [Row.name]: Row, [Progress.name]: Progress},
  name: 'getCoupon',
  data () {
    return {
      checked: false,
      result: [],
      couponlist: [],
      prograsstxt: 0,
      totaltxt: {}
    }
  },
  mounted () {
    this.init()
    this.$nextTick(() => {
      document.getElementsByClassName('van-progress__pivot')[0].style.background = ''
    })
  },
  methods: {
    handleCheckAll () {
      this.result = []
      this.checked = !this.checked
      if (this.checked == true) {
        this.couponlist.forEach((item) => {
          this.result.push(item.actid)
        })
      }
    },
    gobuy () {
      var arg = isApp()
      if (!isWeixin()) {
        if (arg == '') {
          if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
            this.$router.push({
              path: '/login',
              query: {
                routeval: 'getcoupon'
              }
            })
            return
          }
        }
      }
      if (this.result && this.result.length > 0) {
        var url = this.$ajax.addOrderByCoupon_URL
        var data = {
          actid: this.result.join(','),
          custom_msg_kk: 1
        }
        this.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            if (res.data.islimitEnd == 0) {
              if (getQueryString('pt') && getQueryString('pt') == 'app') {
                var obj = {
                  'type': 'couponpay',
                  'orderid': res.data.orderid,
                  'money': res.data.money,
                  'coupontype': 'pay'
                }
                window.ReactNativeWebView.postMessage(
                  JSON.stringify(obj)
                )
              } else if (getQueryString('pt') && getQueryString('pt') == 'xcx') {
                wx.miniProgram.navigateTo({url: '/pages/pay/main?id=' + res.data.orderid + '&money=' + res.data.money + '&getcoupon=1'})
              } else {
                this.$router.push('/pay?id=' + res.data.orderid + '&money=' + res.data.money + '&getcoupon=1')
              }
            }
          } else {
            this.$dialog.alert({
              message: res.data.msg,
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '确定',
              closeOnPopstate: false
            }).then(() => {
              // on close
              this.$dialog.close()
            })
          }
        })
      } else {
        this.$toast('请选择要购买的券')
      }
    },
    numberFormat  (value) {
      var param = {}
      var k = 10000,
        sizes = ['', '万', '亿', '万亿'],
        i
      if (value < k) {
        param.value = value
        param.unit = ''
      } else {
        i = Math.floor(Math.log(value) / Math.log(k))

        param.value = ((value / Math.pow(k, i))).toFixed(0)
        param.unit = sizes[i]
      }
      return param
    },
    init () {
      fenxiang({path: 'getCoupon'})
      var url = this.$ajax.getCouponActList_URL
      this.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          this.couponlist = res.data.data.couponlist
          this.prograsstxt = parseFloat(parseInt(res.data.data.salesnum) / parseInt(res.data.data.total) * 100).toFixed(0)
          this.totaltxt = this.numberFormat(res.data.data.total)
          this.result.push(this.couponlist[0].actid)
        }
      })
    }
  },
  watch: {
    result (value) {
      console.log(value)
      if (value.length >= 2) {
        this.checked = true
      } else {
        this.checked = false
      }
    }
  }
}
</script>
<style>
  .scc .van-progress{
    border-radius: 25px;
  }
  .scc .van-progress__pivot{
    min-width: 25px;
    height: 25px;
    border-radius: 25px;
    background-image: url("/static/images/cv1.png");
    background-position: center;
    background-repeat: no-repeat;
    /*background: url("/static/images/cv1.png") center no-repeat;*/
    background-size: 100% 100%;
    background-color: transparent;
  }
</style>

<style scoped lang="scss">
.container{
  background: #fb4142;
  .item{
    display: flex;
    align-items: center;
  }
  .couponlist{
    /*padding: 15px;*/
    img{
      width: 100%;
      /*margin-bottom: 15px;*/
    }
  }
  .progress_d{
    width: 60%;
    text-align: right;
    font-size: 16px;
    color:#fef901;
    margin-bottom: 3px;
    font-weight: 700;
  }
  .scc{
    width: 90%;
    margin:0 auto;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .progress_c{
      width: 80%;
    }
    div:nth-child(2){
      width: 20%;
      font-size: 14px;
      color:#fff;
      font-weight: 600;
      text-align: center;
      .m{
        font-size: 16px;
      }
    }
  }
  .sc{
    width: 90%;
    margin: 0 auto;
    background: #fce9da;
    border-radius: 10px;
    padding:15px;
    padding-bottom: 0;
    .item{
     padding-bottom: 15px;
    }
  }
  .qgbtn{
    width: 70%;
    margin: 20px auto;
    img{
      width: 100%;
    }
  }
  .info{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    background: #908D8D;
    .l{
      width: 30%;
      div:nth-child(1){
        font-size: 20px;
        text-align: center;
      }
      div:nth-child(2){
        font-size: 16px;
        text-align: center;
      }
    }
    .r{
      width: 70%;
      div:nth-child(1){
        font-size: 18px;
      }
      div:nth-child(2){
        font-size: 16px;
      }
      div:nth-child(3){
        font-size: 14px;
      }
    }
  }
  .bfooter{
    height: 49px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left:0;
    padding: 0 15px;
    border-top: solid 1px #eee;
    .btn{
      width: 80px;
      height: 35px;
      text-align: center;
      color:#fff;
      line-height: 35px;
      background: #fb5b41;
      border-radius: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productdetail/getCoupon.vue